
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.501 14.379c-3.793 0-6.88-3.086-6.88-6.879S3.707.621 7.501.621c3.793 0 6.878 3.086 6.878 6.879s-3.085 6.879-6.878 6.879z"}}),_c('path',{attrs:{"fill":"#070808","d":"M7.501 1.145A6.362 6.362 0 0113.855 7.5a6.362 6.362 0 01-6.354 6.355A6.363 6.363 0 011.145 7.5a6.363 6.363 0 016.356-6.355m0-1.047a7.402 7.402 0 10-.002 14.804A7.402 7.402 0 007.501.098z"}})])
          )
        }
      }
    